import {
  AfterViewInit,
  Component,
  Inject,
  OnChanges,
  OnInit,
  PLATFORM_ID,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {AsyncPipe, NgForOf, NgIf} from "@angular/common";
import {AttachmentFromIdPipe} from "../../../pipes/attachmentFromId/attachment-from-id.pipe";
import {BookmarksSectionComponent} from "../../modules/bookmarks-section/bookmarks-section.component";
import {BreacrumbsComponent} from "../../elements/breacrumbs/breacrumbs.component";
import {ContextSectionComponent} from "../../modules/context-section/context-section.component";
import {CurrentlySectionComponent} from "../../modules/currently-section/currently-section.component";
import {EvenementSitSectionComponent} from "../../modules/evenement-sit-section/evenement-sit-section.component";
import {FreeSectionComponent} from "../../modules/free-section/free-section.component";
import {ItineraireSectionComponent} from "../../modules/itineraire-section/itineraire-section.component";
import {ListLinksSectionComponent} from "../../modules/list-links-section/list-links-section.component";
import {ListPagesSectionComponent} from "../../modules/list-pages-section/list-pages-section.component";
import {MediaAttachmentComponent} from "../../elements/media-attachment/media-attachment.component";
import {NewsletterSectionComponent} from "../../modules/newsletter-section/newsletter-section.component";
import {PageNavigationComponent} from "../../elements/page-navigation/page-navigation.component";
import {SelectionSitSectionComponent} from "../../modules/selection-sit-section/selection-sit-section.component";
import {SwiperModule} from "swiper/angular";
import {TextImagesSectionComponent} from "../../modules/text-images-section/text-images-section.component";
import {WordpressService} from "../../../services/wordpress.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SEOService} from "../../../services/seo.service";
import {ThemeService} from "../../../services/theme.service";
import {AnalyticsService} from "../../../services/analytics.service";
import {SynapiSelection} from "../../../models/Synapi/SynapiSelection";
import {SynapiService} from "../../../services/synapi.service";
import {SynapiPredicate} from "../../../models/Synapi/SynapiPredicate";
import {PageSelectionSitSection} from "../../../models/Page/Sections/PageSelectionSitSection";
import {RedirectionService} from "../../../services/redirection.service";

@Component({
  selector: 'selection',
  standalone: true,
    imports: [
        AsyncPipe,
        AttachmentFromIdPipe,
        BookmarksSectionComponent,
        BreacrumbsComponent,
        ContextSectionComponent,
        CurrentlySectionComponent,
        EvenementSitSectionComponent,
        FreeSectionComponent,
        ItineraireSectionComponent,
        ListLinksSectionComponent,
        ListPagesSectionComponent,
        MediaAttachmentComponent,
        NewsletterSectionComponent,
        NgForOf,
        NgIf,
        PageNavigationComponent,
        SelectionSitSectionComponent,
        SwiperModule,
        TextImagesSectionComponent
    ],
  templateUrl: './selection.component.html',
  styleUrl: './selection.component.scss'
})
export class SelectionComponent implements OnInit, AfterViewInit{

  selection: SynapiSelection = new SynapiSelection();
  section : PageSelectionSitSection = new PageSelectionSitSection();
  @ViewChild('selectionEl') selectionRef : SelectionSitSectionComponent;
  imageUrl : string;
  imageAlt : string;
  constructor(
    public wordpress : WordpressService,
    public route: ActivatedRoute,
    public seo : SEOService,
    public synapi : SynapiService,
    private themeService: ThemeService,
    private redirectService: RedirectionService,
    private analyticsService: AnalyticsService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}
  ngOnInit() {
    this.route.paramMap.subscribe(async (params) => {
      const slug = params.get("slug");
      if (slug) {
        this.themeService.setCurrentTemplate('page');
        const synapiPredicate = new SynapiPredicate();
        synapiPredicate.id  = slug;
        await this.synapi.getSelection(synapiPredicate).then((selection) => this.initSelection(selection)).catch((e) => {
          this.redirectService.setNotFound("Sélection non trouvée");
        });
      } else {
        this.redirectService.setNotFound("Sélection non trouvée");
      }
    });
  }

  initSelection(selection: SynapiSelection){
    this.selection = selection;
    this.section.selection_sit = selection.id;
    this.seo.setTitles(selection.name + ' - Le Var');
    this.seo.setRobots('index','follow');
    this.analyticsService.trackPageView(this.router.url, selection.name + ' - Le Var');
  }

  ngAfterViewInit(){
    setTimeout(()=>{
      if(this.selectionRef?.listRef){
        const subscription = this.selectionRef.listRef.onListChange.subscribe(()=>{
          const items = this.selectionRef.listItems.items;
          if(items.length>0){
            this.imageAlt = items[0].Title;
            this.imageUrl = items[0].ImageUrl;
            this.seo.setImages(this.imageUrl);
            subscription?.unsubscribe();
          }
        })
      }
    },500);

  }
}
